export const TenantSettingNames = {
  HAS_DEVICES: 'hasDevices',
} as const;
